/* PLAB-05 (#78). Was an inline <script> in sections/s-content-modal.liquid. It publishes
   window.WOOPF.openModal / closeModal on DOMContentLoaded, which the product section and
   s-ask-a-vet-hero call. A sibling of section-content-modal.js, which is a minified browserify
   bundle with no source in this repository. */

/* A11Y-16 (#295): the content modal is a dialog. The product page's Features & Benefits, Shipping
   & Returns and FAQ buttons open it in two ways: the capture-phase handler in
   section-main-product-size-compare.js calls window.WOOPF.openModal below, and
   section-main-product.js publishes "content-modal:open" to the minified section-content-modal.js.
   Once either has shown the modal (the next frame), window.CDialog (assets/c-dialog.js) makes the
   page behind inert, moves focus to the close button, clicks that button on Escape, and on close
   hands focus back to the button that opened it. Every close path releases the page: closeModal
   below (the close button, a click outside, window.WOOPF.closeModal), a capture-phase listener for
   the close button and the .js-overlay the minified driver closes on, and a Theme Editor unload
   of the modal's section. The modal and the overlay are looked up when an event runs, never
   cached, and a modal that has left the page is never handed to CDialog. Without c-dialog.js the
   modal opens and closes as before. Guarded so a second run of this file binds nothing twice. */
(() => {
  window.WOOPF = window.WOOPF || {};
  if (window.WOOPF.contentModalDialog) return;

  const CLOSER = ".js-content-modal__closer";
  const OVERLAY = ".js-overlay";
  let openRoot = null;

  const close = (options) => {
    const root = openRoot;
    openRoot = null;
    if (root) window.CDialog?.close(root, options);
  };

  const open = () => {
    const returnFocus = document.activeElement;
    requestAnimationFrame(() => {
      const modal = document.querySelector("s-content-modal");
      if (!window.CDialog || !modal || !modal.isConnected) return;
      if (!modal.classList.contains("is-open") || openRoot === modal) return;
      if (openRoot) close({ restoreFocus: false });

      openRoot = modal;
      window.CDialog.open({
        root: modal,
        keep: [document.querySelector(OVERLAY)],
        initialFocus: modal.querySelector(CLOSER),
        returnFocus,
        fallbackFocus: document.getElementById("MainContent"),
        onEscape: () => {
          const closer = modal.querySelector(CLOSER);
          if (closer) closer.click();
          else close();
        }
      });
      // A hidden close button refuses focus; never leave it on the inert trigger or <body>.
      if (!modal.contains(document.activeElement)) modal.focus({ preventScroll: true });
    });
  };

  document.addEventListener(
    "click",
    (e) => {
      if (!openRoot || !e.target || typeof e.target.closest !== "function") return;
      const closer = e.target.closest(CLOSER);
      if ((closer && openRoot.contains(closer)) || e.target.closest(OVERLAY)) close();
    },
    true
  );

  document.addEventListener("shopify:section:unload", (e) => {
    if (!openRoot) return;
    if (!openRoot.isConnected || (e.target && e.target.contains && e.target.contains(openRoot))) {
      close({ restoreFocus: false });
    }
  });

  if (window.PubSub && typeof window.PubSub.subscribe === "function") {
    window.PubSub.subscribe("content-modal:open", open);
  }

  window.WOOPF.contentModalDialog = { open, close };
})();

  document.addEventListener("DOMContentLoaded", () => {
    const modal = document.querySelector("s-content-modal");
    const modalHeader = modal?.querySelector(".s-content-modal__header");
    const modalBody = modal?.querySelector(".js-content-modal__body");
    const modalClose = modal?.querySelector(".js-content-modal__closer");

    const triggers = document.querySelectorAll(".js-main-product__content-wrapper");

    const handleOutsideClick = (e) => {
      // close only if click is outside modal
      if (modal && !modal.contains(e.target)) closeModal();
    };

    const openModal = (titleOrOpts, contentMaybe) => {
      if (!modal || !modalBody || !modalHeader) return;

      let title = '';
      let content = '';
      let mode = 'default'; // 'default' | 'wide'

      if (typeof titleOrOpts === 'object' && titleOrOpts) {
        title = titleOrOpts.title || '';
        content = titleOrOpts.content || '';
        mode = titleOrOpts.mode || 'default';
      } else {
        title = titleOrOpts || '';
        content = contentMaybe || '';
      }

      modalBody.innerHTML = content;

      const titleEl = modal.querySelector(".js-content-modal__title");
      if (titleEl) titleEl.innerText = title;

      // OPT-IN wide mode
      modal.classList.toggle('s-content-modal--wide', mode === 'wide');

      modal.style.display = "block";
      modal.classList.add("is-open", "fade-in");
      modalHeader.style.display = "flex";

      setTimeout(() => {
        document.addEventListener("click", handleOutsideClick);
      }, 10);

      /* A11Y-16 (#295): the modal is shown; make it a dialog (the block at the top of this file) */
      window.WOOPF?.contentModalDialog?.open();
    };

    const closeModal = () => {
      if (!modal) return;

      modal.classList.remove("is-open", "fade-in");
      modal.classList.remove("s-content-modal--wide"); // reset mode
      modal.style.display = "none";
      if (modalHeader) modalHeader.style.display = "none";

      document.removeEventListener("click", handleOutsideClick);

      /* A11Y-16 (#295): release the page behind and hand focus back (a no-op when already done) */
      window.WOOPF?.contentModalDialog?.close();
    };

    // PDP accordion triggers (your existing behavior)
    triggers.forEach(trigger => {
      trigger.addEventListener("click", () => {
        const title = trigger.getAttribute("data-title") || "Info";
        const content = trigger.querySelector(".js-main-product__content-text")?.innerHTML || "";
        openModal(title, content);
      });
    });

    if (modalClose) {
      modalClose.addEventListener("click", (e) => {
        e.stopPropagation();
        closeModal();
      });
    }

    // IMPORTANT: expose functions, DO NOT CALL THEM here
    window.WOOPF = window.WOOPF || {};
    window.WOOPF.openModal = openModal;
    window.WOOPF.closeModal = closeModal;
  });
